import React from 'react';
import { Stack } from '@fiverr-private/layout_components';
import { Heading, Text } from '@fiverr-private/typography';
import NoResults from '../../../../assets/no-results.svg';
import { AppI18n } from '../../../i18n';

export const TableNoResultsState = () => (
  <Stack gap="10" direction="column" alignItems="center" justifyContent="center" minHeight="60vh">
    <img src={NoResults} alt="error" width={152} height={130} />
    <Stack direction="column" justifyContent="center" alignItems="center">
      <Heading as="h4" textAlign="center">
        <AppI18n k="no_results.title" />
      </Heading>
      <Text textAlign="center">
        <AppI18n k="no_results.description" />
      </Text>
    </Stack>
  </Stack>
);
